import React from "react";
import {CPreloader} from "../UI";
import "./style.scss";

export default ({children, isPreloader, isFullscreen, isAbsolute}) => {
    return (
        <div className={`loading-message-container ${isFullscreen ? '-fullscreen' : ''} ${isAbsolute ? '-absolute' : ''}`}>
            {isPreloader && <div><CPreloader /></div>}
            <div className="loading-message">{children}</div>
        </div>
    );
}
